<template>
  <div class="studentTrajectory-container">
    <div class="studentTrajectory-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="studentTrajectory-right flex_1 div-layout">
        <module-title title="学生行为轨迹" />
        <div class="studentTrajectory-right-contain">
          <p>{{ treeNode.name }}</p>
          <el-form
            ref="schoolCardSearchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="120px"
          >
            <el-form-item label="年级：" prop="grade">
              <el-select
                v-model="searchForm.grade"
                placeholder="选择年级"
                name="grade"
                size="medium"
                class="edit-form-input"
                @change="gradeChange"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.grade"
                  :label="item.gradeName"
                  :value="item.grade"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="班级：" prop="classes">
              <el-select
                v-model="searchForm.classes"
                placeholder="选择班级"
                name="classes"
                size="medium"
                class="edit-form-input"
                @change="classesChange"
              >
                <el-option
                  v-for="item in classesList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="学生：" prop="studentCode">
              <el-select
                v-model="searchForm.studentCode"
                placeholder="选择学生"
                name="studentCode"
                size="medium"
                class="edit-form-input"
              >
                <el-option
                  v-for="item in studentList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item style="margin-left:50px;">
              <el-button :loading="positionLoading" type="primary" size="medium" icon="el-icon-search" @click="fetchStudentTrajectory">
                {{ positionLoading?'查询中':'查询' }}
              </el-button>
              <el-button size="medium" icon="el-icon-refresh-right" @click="fetchStudentTrajectory">
                刷新
              </el-button>
            </el-form-item>
          </el-form>
          <div class="amap-wrapper">
            <el-amap
              :zoom="amapObj.zoom"
              :zooms="[3,20]"
              :center="amapObj.center"
              :plugin="amapObj.plugin"
              :amap-manager="amapObj.amapManager"
              :events="amapObj.events"
              :expand-zoom-range="true"
              vid="amapStudent"
            >
              <el-amap-marker
                v-for="(marker, index) in amapObj.markers"
                :key="index"
                :position="marker.position"
                :events="marker.events"
                :label="marker.label"
                animation="AMAP_ANIMATION_DROP"
              />
              <el-amap-info-window
                v-if="amapObj.window"
                :position="amapObj.window.position"
                :visible="amapObj.window.visible"
                :content="amapObj.window.content"
                :close-when-click-map="true"
                :offset="[0, -25]"
                :is-custom="true"
              />
            </el-amap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AMapManager } from 'vue-amap';
import { getStudentTrajectory } from '@/api/systemMaintenance/devicManage/schoolCardManage';
import { getStageGradeClass, getStudentList } from '@/api/systemMaintenance/devicManage/common';
export default {
  name: 'StudentTrajectory',
  data() {
    const amapManager = new AMapManager();
    return {
      treeNode: {},
      searchForm: {
        grade: '',
        classes: '',
        studentCode: ''
      },
      positionLoading: false,
      studentPositionList: [], // 学生定位数组
      gradeList: [], // 年级数组
      classesList: [], // 班级数组
      studentList: [], //  学生数组
      amapObj: {
        amapManager, // 地图管理对象 amap 实例
        geocoder: {}, // 位置服务实例
        center: [112.92231, 28.16934],
        pointX: 0,
        pointY: 0,
        zoom: 15,
        window: '',
        markers: [],
        events: {
          init(o) {
            // console.log(o.getCenter());
          }
        },
        plugin: [
          {
            // 地址服务
            pName: 'Geocoder',
            events: {
              init: o => {
                this.amapObj.geocoder = o;
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    // 树点击事件
    treeNodeClick(data) {
      this.amapObj.markers = [];
      this.amapObj.window = '';
      this.treeNode = data;
      this.fetchGradeList();
    },

    // 获取学生定位
    fetchStudentTrajectory() {
      this.amapObj.markers = [];
      this.amapObj.window = '';
      if (!this.searchForm.studentCode) {
        this.$message.warning('当前没有学生,无法查询');
      } else {
        this.positionLoading = true;
        getStudentTrajectory(this.searchForm.studentCode).then((res) => {
          if (res.data && res.data.length > 0) {
            this.studentPositionList = res.data;
            let marker = {};
            let address = ''; // 行政地址
            this.studentPositionList.forEach((poi, index) => {
              const { pointX, pointY } = poi;
              marker = {
                position: [+pointY, +pointX],
                events: {
                  click: markerE => {
                    this.amapObj.pointX = markerE.lnglat.lng;
                    this.amapObj.pointY = markerE.lnglat.lat;
                    this.amapObj.center = [markerE.lnglat.lng, markerE.lnglat.lat];
                  },
                  mouseover: markerE => {
                  // 获取行政地址
                    this.amapObj.geocoder.getAddress([+pointY, +pointX], (status, result) => {
                      if (status === 'complete' && result.info === 'OK') {
                        if (result && result.regeocode) {
                          address = result.regeocode.formattedAddress;
                          this.amapObj.window = {
                            position: [+pointY, +pointX],
                            content: `<div class="studentInfo">
                                        <p>时间：${poi.pointDate}</p>
                                        <p>位置：${address}</p>
                                      </div>
                                      <div class="corner"></div>`,
                            visible: false
                          };
                          this.$nextTick(() => {
                            this.amapObj.window.visible = true;
                          });
                        }
                      }
                    });
                  },
                  mouseout: markerE => {
                    this.amapObj.window.visible = false;
                  }
                },
                label: { content: index + 1, offset: [index < 99 ? 3 : 0, 3] }
              };
              this.amapObj.markers.push(marker);
            });
            this.amapObj.zoom = 20;
            // 所有搜索坐标的中心点
            this.amapObj.center = [+this.studentPositionList[0].pointY, +this.studentPositionList[0].pointX];
            this.positionLoading = false;
          } else {
            this.positionLoading = false;
            this.amapObj.markers = [];
            this.amapObj.window = '';
            this.$message.warning('查不到当前学生的位置信息');
          }
        }).catch((err) => {
          console.log(err);
          this.positionLoading = false;
        });
      }
    },

    // 获取年级
    fetchGradeList() {
      getStageGradeClass(this.treeNode.code).then(res => {
        if (res.data && res.data.gradeClassVOList && res.data.gradeClassVOList.length > 0) {
          this.gradeList = res.data.gradeClassVOList;
          this.searchForm.grade = this.gradeList[0].grade;
          this.gradeChange(this.searchForm.grade);
        } else {
          this.gradeList = [];
          this.searchForm.grade = '';
        }
      });
    },

    // 年级选择
    gradeChange(val) {
      const gradeObj = this.gradeList.find(x => x.grade === val);
      this.classesList = gradeObj && gradeObj.classVOList ? gradeObj.classVOList : [];
      if (gradeObj && gradeObj.classVOList && gradeObj.classVOList.length > 0) {
        this.classesList = gradeObj.classVOList;
        this.searchForm.classes = this.classesList[0].code;
        this.classesChange(this.searchForm.classes, true);
      } else {
        this.$message.warning('当前年级下没有班级！无法查询');
        this.classesList = [];
        this.studentList = [];
        this.amapObj.window = '';
        this.searchForm.studentCode = '';
        this.searchForm.classes = '';
      }
    },

    // 班级选择
    classesChange(val, first) {
      const searchForm = {
        schoolCode: this.treeNode.code,
        grade: this.searchForm.grade,
        classCode: val,
        pageNum: 1,
        pageSize: 100,
        queryType: 1
      };
      getStudentList(searchForm)
        .then(res => {
          if (res.data && res.data.list && res.data.list.length > 0) {
            this.studentList = res.data.list;
            this.searchForm.studentCode = this.studentList[0].code;
            if (first) {
              this.fetchStudentTrajectory();
            }
          } else {
            this.$message.warning('当前年级下没有学生,无法查询');
            this.studentList = [];
            this.studentPositionList = [];
            this.amapObj.markers = [];
            this.searchForm.studentCode = '';
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.studentTrajectory-container {
  .studentTrajectory-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .studentTrajectory-right {
      .studentTrajectory-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
    }
  }
  .edit-form-input {
    width: 10vw;
  }
  .amap-wrapper {
    width: 100%;
    height: 650px;
  }
}
</style>
